import React, { useState, useEffect, useMemo } from 'react';
import { getVehicleRequestAPI, createVehicleRequest, editVehicleReq, deleteVehicleRequest } from '../../services/vm/apiController';
import { useSelector, useDispatch } from 'react-redux';
import { setBreadCrumb, removeAllBreadCrumb } from '../../store/reducers/menu_reducer';
import { loggedInUser, factoryId } from '../../store/reducers/account_reducer';
import { TABLE_DEFAULT_LIMIT, DEBOUNCE_DELAY } from '../../util/constant';
import { Table, Modal, Button, Form, FloatingLabel, Row, Col, Alert } from 'react-bootstrap';
import { formatDate } from '../../util/helper';
import { toast, ToastContainer } from 'react-toastify';
import { DeleteIcon, EditIcon, ViewIcon } from './components/icons';
import { Link, useLocation } from 'react-router-dom';
import moment from 'moment';
import 'react-toastify/dist/ReactToastify.css';
import AlertIcon from '../../img.svg';
import FactoryDropdown from './FactoryDropdown';
import PaginationInPage from '../Pagination';
import useDebounce from '../useDebounce';

const VehicleRequestsList = (props) => {
  const formFields = {
    model: '',
    vehicleType: '',
    requestedBy: '',
    initiatedBy: '',
    requestedDate: '',
    reason: '',
    file1: null,
    file1Name: '',
    file2: null,
    file2Name: '',
  };
  const dispatch = useDispatch();

  const search = useLocation().search;
  const status__ = new URLSearchParams(search).get('status');

  let user = useSelector(loggedInUser);
  const [modelName, setModelName] = useState('');
  const [status, setStatus] = useState(status__ ?? '');
  const [machineRequests, setMachineRequests] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [show, setShow] = useState(false);
  const [vehicleForm, setVehicleForm] = useState(formFields);
  const [validated, setValidated] = useState(false);
  const [showConfirmModel, setShowConfirmModel] = useState(false);
  const handleCloseConfirmModal = () => {
    setShowConfirmModel(false);
  };
  const [idToDeleted, setIdToDeleted] = useState('');
  const [invalidFileType, setInvalidFileType] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const factoryId_ = useSelector(factoryId);

  const handleClose = () => setShow(false);

  const handleShow = () => {
    setShow(true);
    setValidated(false);
    setVehicleForm(formFields);
  };

  const handleShowConfirmModal = (e, id) => {
    e.preventDefault();
    setShowConfirmModel(true);
    setIdToDeleted(id);
  };

  const getVehicleRequests = async (limit = TABLE_DEFAULT_LIMIT, offset = 0, vehicleRequestId = 0) => {
    try {
      let condition = {
        name: modelName || '',
        status: status || '',
      };
      if (user && user.factoryId) {
        condition['factoryId'] = user.factoryId;
      }
      const machineRequest = await getVehicleRequestAPI(offset, limit, condition, vehicleRequestId);
      return vehicleRequestId === 0
        ? {
            data: (machineRequest && machineRequest.data.rows) || [],
            totalRecords: (machineRequest && machineRequest.data && machineRequest.data.count) || 0,
          }
        : {
            data: (machineRequest && machineRequest.data) || [],
          };
    } catch (e) {
      console.error(e);
      return {
        errorMessage: e.message,
      };
    }
  };

  const handleChange = (event) => {
    event.preventDefault();
    let name = event.target.name;
    let value = event.target.value;
    setVehicleForm({ ...vehicleForm, [name]: value });
  };

  const handleVehicleTypeSelect = (e) => {
    e.preventDefault();
    let name = e.target.name;
    let value = e.target.value;
    setVehicleForm({ ...vehicleForm, [name]: value });
  };

  const onChangeDocumentOne = (e) => {
    e.preventDefault();
    if (e.target.files[0] && e.target.files[0].name.match(/\.(exe|apk|bat|cmd|com|dll|jar|msi|py|sh)$/)) {
      setVehicleForm({ ...vehicleForm, file1: null, file1Name: '' });
      setInvalidFileType(true);
      toast.error('Please select a valid file type.');
    } else {
      setInvalidFileType(false);
      setVehicleForm({ ...vehicleForm, file1: e.target.files[0] || null, file1Name: e.target.files[0]?.name || '' });
    }
  };

  const onChangeDocumentTwo = (e) => {
    e.preventDefault();
    if (e.target.files[0] && e.target.files[0].name.match(/\.(exe|apk|bat|cmd|com|dll|jar|msi|py|sh)$/)) {
      setVehicleForm({ ...vehicleForm, file2: null, file2Name: '' });
      setInvalidFileType(true);
      toast.error('Please select a valid file type.');
    } else {
      setInvalidFileType(false);
      setVehicleForm({ ...vehicleForm, file2: e.target.files[0] || null, file2Name: e.target.files[0]?.name || '' });
    }
  };

  const editVehicleRequest = (event, id, factoryId) => {
    event.preventDefault();
    localStorage.setItem('factoryId', factoryId);
    const getSingleVehicle = async () => {
      const data = await getVehicleRequests(TABLE_DEFAULT_LIMIT, currentPage, id);
      data.data.requestedDate = moment(data.data.requestedDate).format('YYYY-MM-DD');
      setVehicleForm(data.data);
    };
    getSingleVehicle();
    setShow(true);
  };

  const handleRemove = (event, id) => {
    event.preventDefault();
    const deleteVehicle = async () => {
      const data = await deleteVehicleRequest(id);
      toast.success(data.data);
      setShowConfirmModel(false);
      getRequests();
    };
    deleteVehicle();
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (invalidFileType) {
      toast.error('Please select a valid file.', { autoClose: 2000 });
      return;
    }
    const formData = new FormData();
    for (var key in vehicleForm) {
      if (key === 'file1' || key === 'file1Name' || key === 'file2' || key === 'file2Name') continue;
      formData.append(key, vehicleForm[key]);
    }
    if (vehicleForm.file1 !== null && typeof vehicleForm.file1 !== 'string')
      formData.append('file1', vehicleForm['file1'], vehicleForm.file1Name);
    if (vehicleForm.file2 !== null && typeof vehicleForm.file2 !== 'string')
      formData.append('file2', vehicleForm['file2'], vehicleForm.file2Name);

    if (formData.get('id') && formData.get('id') !== null) {
      try {
        setIsButtonDisabled(false);
        await editVehicleReq(formData, formData.get('id'));
        toast.success('Vehicle Request updated successfully');
        setShow(false);
        getRequests();
      } catch (err) {
        toast.error(err.message, { autoClose: 3000 });
      }
    } else {
      if (isButtonDisabled) {
        return; // If button is disabled, return early
      }
      setIsButtonDisabled(true); // Disable the button
      try {
        await createVehicleRequest(formData);
        toast.success('Vehicle Request added successfully');
        setShow(false);
        getRequests();
      } catch (err) {
        toast.error(err.message, { autoClose: 2000 });
      } finally {
        // Enable the button after a delay of 3 seconds
        setTimeout(() => {
          setIsButtonDisabled(false);
        }, 500);
      }
    }
  };

  const formDataToJson = (formData) => {
    const json = {};
    for (const [key, value] of formData.entries()) {
      json[key] = value;
    }
    return json;
  };

  async function getRequests() {
    const data = await getVehicleRequests(TABLE_DEFAULT_LIMIT, currentPage);
    setTotalRecords(data.totalRecords);
    setMachineRequests(data.data);
  }

  useEffect(() => {
    getRequests();
  }, [currentPage]);

  useDebounce(
    () => {
      if (currentPage !== 1) {
        setCurrentPage(1);
      } else {
        getRequests();
      }
    },
    [modelName, status],
    DEBOUNCE_DELAY
  );

  useEffect(() => {
    dispatch(removeAllBreadCrumb());
    dispatch(
      setBreadCrumb({
        label: 'Machine Request List',
        value: '/machine-request',
      })
    );
  }, []);

  return (
    <React.Fragment>
      <ToastContainer />
      <nav className="" aria-label="breadcrumb">
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <Link to="/vm/vehicle-requests">Vehicle Request List</Link>
          </li>
        </ol>
      </nav>
      <div className="card top-card">
        <div className="card-body">
          <div className="row">
            <FactoryDropdown onFactoryChange={getRequests} />
            <div className="form-group col-md-2 col-lg-2">
              <label htmlFor="exampleInputEmail1">Model Name</label>
              <input
                type="text"
                className="form-control"
                id="exampleInputEmail1"
                placeholder="Please enter Model Name"
                aria-describedby="emailHelp"
                value={modelName}
                onChange={(e) => {
                  setModelName(e.target.value);
                }}
              />
            </div>
            <div className="form-group col-md-2 col-lg-2">
              <label htmlFor="exampleInputEmail1">Status</label>
              <Form.Select
                value={status}
                onChange={(e) => {
                  setStatus(e.target.value);
                }}
                className="all-select-custom"
                aria-label="Default select example"
              >
                <option value="" disabled hidden>
                  Select Status
                </option>
                <option value="VEHICLE REQUESTED">Vehicle Requested</option>
                <option value="PO REQUESTED">PO Requested</option>
                <option value="RUNNING VEHICLE">Running Vehicle</option>
                <option value="SCRAP-RESELL">Scrap / Resell</option>
              </Form.Select>
            </div>
            <div className="form-group col-md-5 col-lg-5">
              <div className="btn-wrapper justify-content-start cmt-3">
                {/* <button type="button" className="btn app-btn-primary" onClick={getRequests}>Search</button> */}
                <button
                  type="button"
                  className="btn app-btn-default"
                  onClick={(e) => {
                    setModelName('');
                    setStatus('');
                  }}
                >
                  Reset
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="card">
        <div className="card-header white-color" style={{ padding: '1rem 1.7rem' }}>
          {factoryId_ ? (
            <>
              <h4 className="card-title mb-0" style={{ fontSize: '16px' }}>
                New Vehicle Requests | {totalRecords ?? 0}
              </h4>
              <button type="button" className="btn app-btn-default dark-color" onClick={handleShow}>
                New Request
              </button>
            </>
          ) : (
            <h4 className="card-title mb-0" style={{ fontSize: '16px', color: 'red' }}>
              Please Select a Factory
            </h4>
          )}
        </div>
        {factoryId_ ? (
          <div className="card-body px-0 vehicle-requests-table pt-0 pb-0">
            <div className="row">
              <div className="col">
                <Table responsive striped>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Vehicle Name</th>
                      <th>Vehicle Type</th>
                      <th>Requested By</th>
                      <th>Initiated By</th>
                      <th>Requested Date</th>
                      <th>Reason</th>
                      <th>Status</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {machineRequests?.map((request, index) => {
                      return (
                        <tr key={request.id}>
                          <td>{(currentPage - 1) * TABLE_DEFAULT_LIMIT + (index + 1)}</td>
                          <td>{request.model}</td>
                          <td>{request.vehicleType}</td>
                          <td>{request.requestedBy}</td>
                          <td>{request.initiatedBy}</td>
                          <td>{formatDate(request.requestedDate)}</td>
                          <td>{request.reason}</td>
                          <td>{request.status}</td>
                          <td className="actions">
                            <div className="d-flex">
                              <div className="view">
                                <button
                                  onClick={(event) => {
                                    localStorage.setItem('factoryId', request?.factoryId);
                                  }}
                                  style={{ border: 'none', backgroundColor: 'white' }}
                                >
                                  <Link to={`/vm/vehicle-requests/${request.id}`}>
                                    <ViewIcon />
                                  </Link>
                                </button>
                              </div>
                              <div className="edit">
                                <button style={{ border: 'none', backgroundColor: 'white' }}>
                                  <span
                                    className="edit-icon"
                                    onClick={(event) => editVehicleRequest(event, request.id, request?.factoryId)}
                                  >
                                    <EditIcon />
                                  </span>
                                </button>
                              </div>
                              <div className="remove">
                                <button style={{ border: 'none', backgroundColor: 'white' }}>
                                  <Link className="delete" onClick={(e) => handleShowConfirmModal(e, request.id)} to="/">
                                    <DeleteIcon />
                                  </Link>
                                </button>
                              </div>
                            </div>
                            {/* <div className="d-flex gap-2">
                          <div className="view">
                          
                          </div>
                          </div>
                          <div className="edit">
                          
                          </div>
                          <div className="delete">
                          
                          </div> */}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
                <PaginationInPage
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  totalRecords={totalRecords}
                  TABLE_DEFAULT_LIMIT={TABLE_DEFAULT_LIMIT}
                />
              </div>
            </div>
          </div>
        ) : (
          ''
        )}
      </div>
      <Modal size="lg" show={show} backdrop="static" keyboard={false} className="request-modal">
        <Modal.Header>
          <Modal.Title>{vehicleForm.id === undefined ? 'Add Vehicle Request' : 'Edit Vehicle Request'}</Modal.Title>
          <button type="button" className="btn-close" aria-label="Close" onClick={handleClose}></button>
        </Modal.Header>
        <Modal.Body>
          <Form autoComplete="off" noValidate validated={validated}>
            <Row>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Vehicle Name" className="mb-3">
                  <Form.Control
                    className="input"
                    name="model"
                    value={vehicleForm.model}
                    onChange={handleChange}
                    type="text"
                    placeholder="name@example.com"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingSelect" label="Vehicle Type">
                  <Form.Select
                    value={vehicleForm.vehicleType}
                    onChange={handleVehicleTypeSelect}
                    name="vehicleType"
                    aria-label="Floating label select example"
                    required
                  >
                    <option>Vehicle Type</option>
                    <option value="Ashok-Leyland">Ashok Leyland</option>
                    <option value="Bolero">Bolero</option>
                    <option value="M-Sup-Carry">M.Sup.Carry</option>
                    <option value="Tata-Intra">Tata Intra</option>
                    <option value="Tata-Megha">Tata Megha</option>
                    <option value="Tata-Ace">Tata Ace</option>
                    <option value="Others">Others</option>
                  </Form.Select>
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Requested By" className="mb-3">
                  <Form.Control
                    className="input"
                    name="requestedBy"
                    value={vehicleForm.requestedBy}
                    onChange={handleChange}
                    type="text"
                    placeholder="name@example.com"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Initiated By" className="mb-3">
                  <Form.Control
                    className="input"
                    name="initiatedBy"
                    value={vehicleForm.initiatedBy}
                    onChange={handleChange}
                    type="text"
                    placeholder="name@example.com"
                    required
                  />
                </FloatingLabel>
              </Col>
            </Row>
            <Row className="mb-4">
              <Col xs={4} className="requested-date">
                <FloatingLabel controlId="floatingInput" label="Requested Date" className="mb-3">
                  <Form.Control
                    className="input"
                    name="requestedDate"
                    value={vehicleForm.requestedDate}
                    onChange={handleChange}
                    type="date"
                    placeholder="name@example.com"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={8}>
                <FloatingLabel controlId="floatingInput" label="Reason" className="mb-3">
                  <Form.Control
                    className="input"
                    name="reason"
                    value={vehicleForm.reason}
                    onChange={handleChange}
                    type="text"
                    placeholder="name@example.com"
                    required
                  />
                </FloatingLabel>
              </Col>
            </Row>
            <Row className="bottom-content">
              <Col xs={12}>
                <Alert.Heading>Documents</Alert.Heading>
                <hr />
              </Col>
              <Col xs={6}>
                <Form.Group controlId="formFile" className="mb-3 images-box">
                  <Form.Label>Document 1</Form.Label>
                  <Form.Control onChange={onChangeDocumentOne} type="file" name="file" aria-required="false" />
                  {vehicleForm.file1Name !== null ? <p className="mb-0">{vehicleForm.file1Name}</p> : ''}
                </Form.Group>
              </Col>
              <Col xs={6}>
                <Form.Group controlId="formFile" className="mb-3 images-box">
                  <Form.Label>Document 2</Form.Label>
                  <Form.Control onChange={onChangeDocumentTwo} type="file" name="file2" aria-required="false" />
                  {vehicleForm.file2Name !== null ? <p className="mb-0">{vehicleForm.file2Name}</p> : ''}
                </Form.Group>
              </Col>
            </Row>
            <Button type="submit" onClick={handleSubmit} className="add-request-btn mt-4 mb-3">
              {!Object.keys(vehicleForm).includes('id') ? 'Add Request' : 'Update Request'}
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
      <Modal size="sm" show={showConfirmModel} backdrop="static" keyboard={false} className="request-modal">
        <Modal.Header className="bg-danger text-light py-2">
          <Modal.Title>Delete Vehicle Request</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex justify-content-start">
            <img src={AlertIcon} alt="Alert" />
            <p className="ps-3 mb-0">Are you sure? Action cannot be undone.</p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="btn-wrapper">
            <button onClick={handleCloseConfirmModal} className="btn app-btn-default btn-sm">
              Cancel
            </button>
            <button onClick={(event) => handleRemove(event, idToDeleted)} className="btn app-btn-danger btn-sm">
              Delete
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

export default VehicleRequestsList;
